import { getApiAsyn, deleteApiAsyn, baseUrl, getAuthHeaders } from "../../PostAPI";
import { API_URL } from "../../../utils/constant";
import axios from "axios";

const { post } = axios;


export const getAllFavorites = async () => {
  try {
    const result = await getApiAsyn(
      API_URL.FAVORITES.GET_ALL,
      localStorage.getItem("token")
    );
    if (result?.error) {
      return { isError: true, error: result.error };
    }
    return result;
  } catch (error) {
    console.error("Failed to get favorites:", error);
    return { isError: true, error: error.message || "Failed to get favorites" };
  }
};

export const addFavorite = async (menuId) => {
  const url = `${API_URL.FAVORITES.ADD}/${menuId}`;
  try {
    const config = {
      headers: getAuthHeaders(localStorage.getItem("token")),
    };
    const result = await post(baseUrl + url, {}, config);
    if (result?.data?.error) {
      return { isError: true, error: result.data.error };
    }
    return result.data;
  } catch (error) {
    console.error("Failed to add favorite:", error);
    return { isError: true, error: error.message || "Failed to add favorite" };
  }
};

export const removeFavorite = async (menuId) => {
  const url = `${API_URL.FAVORITES.REMOVE}/${menuId}`;
  try {
    const result = await deleteApiAsyn(url, {}, localStorage.getItem("token"));
    if (result?.error) {
      return { isError: true, error: result.error };
    }
    return result;
  } catch (error) {
    console.error("Failed to remove favorite:", error);
    return { isError: true, error: error.message || "Failed to remove favorite" };
  }
};
